import {ButtonOption} from "../../../shared/button-options.component";
import {MessageCollection} from "../../../shared/api/messages/api.models";

export class MessageOptions {
    static readonly relationShipOptions: ButtonOption[] = [
        new ButtonOption(MessageCollection.RELATIONSHIP_MARRIED, 'Married'),
        new ButtonOption(MessageCollection.RELATIONSHIP_IN_RELATIONSHIP, 'In a relationship'),
        new ButtonOption(MessageCollection.RELATIONSHIP_SINGLE, 'Single'),
        new ButtonOption(MessageCollection.RELATIONSHIP_WIDOW, 'Widow'),
    ];

    static readonly lookingFor: ButtonOption[] = [
        new ButtonOption(MessageCollection.GENDER_FEMALE, 'Female'),
        new ButtonOption(MessageCollection.GENDER_SHEMALE, 'Shemale')
    ];

    static readonly photos: ButtonOption[] = [
        new ButtonOption(true, 'Has photo'),
        new ButtonOption(false, 'Has no photo')
    ];

    static readonly daysOfWeekOptions: ButtonOption[] = [
        new ButtonOption('0', 'Monday'),
        new ButtonOption('1', 'Tuesday'),
        new ButtonOption('2', 'Wednesday'),
        new ButtonOption('3', 'Thursday'),
        new ButtonOption('4', 'Friday'),
        new ButtonOption('5', 'Saturday'),
        new ButtonOption('6', 'Sunday'),
    ];

    static readonly nearby: ButtonOption[] = [
        new ButtonOption(true, 'Enabled'),
        new ButtonOption(false, 'Disabled')
    ];
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/messages/components/components/options.model.ts